
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/new",
      function () {
        return require("private-next-pages/users/new/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/new"])
      });
    }
  